module.exports = __webpack_public_path__ + "img/st3.29ddc82e.png";